module.exports = __webpack_public_path__ + "img/word-world.889457e3.webp";